/* eslint-disable react/no-array-index-key */
import {css, useTheme} from '@mui/material';
import {GetStylesFunction} from '@wallaby-ui/core';
import React from 'react';

type LegendItem = {
  label: string;
  color: string;
};
type Props = {
  items: LegendItem[];
  background?: string;
  textColor?: string;
};
export const LightChartLegend: React.FC<Props> = (props) => {
  const {items, background, textColor} = props;
  const theme = useTheme();
  const muiStyles = getStyles({theme, params: {background}});
  return (
    <div css={muiStyles.legendWrapper}>
      {items.map((v, i) => (
        <div key={i} css={muiStyles.row}>
          <div css={muiStyles.circle} style={{background: v.color}} />
          <span css={muiStyles.label} style={{color: textColor || v.color}}>
            {v.label}
          </span>
        </div>
      ))}
    </div>
  );
};
const getStyles: GetStylesFunction = (options) => {
  return {
    legendWrapper: css`
      display: flex;
      flex-direction: column;
      background: var(${options?.params?.background ?? '--dlThemeGray-100'});
      padding: 8px;
      border-radius: 8px;
    `,
    row: css`
      display: inline-flex;
      align-items: center;
      gap: 8px;
    `,
    circle: css`
      width: 10px;
      height: 10px;
      border-radius: 5px;
    `,
    label: css``,
  };
};
